




import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { CampaignItemPaymentStatus } from '@/modules/campaign-item-payment/models/campaign-item-payment-resource.model'

@Component
export default class AdminCampaignItemPaymentStatus extends Vue {
  @Prop({ required: true }) status: CampaignItemPaymentStatus
  @Prop({ required: true }) statusesInPersian: { [key in CampaignItemPaymentStatus]: string }

  private get statusClass() {
    return this.status === CampaignItemPaymentStatus.PAID ? 'text-tes-green' : 'text-tes-orange'
  }
}
